import { usePurchaserSalePriceStore } from "@fero/stores";
import {
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { type ChangeEvent, useState } from "react";

export const PurchaserDiscountsModalDiscountOptions = () => {
  const { purchaserDiscount, setPurchaserDiscount } =
    usePurchaserSalePriceStore();
  const [discountType, setDiscountType] = useState(
    purchaserDiscount ? "per-item" : "default",
  );

  const handleDiscountChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = Math.min(100, Math.max(0, Number(event.target.value)));
    setPurchaserDiscount(String(value));
  };
  const handleDiscountTypeChange = (event: ChangeEvent<HTMLInputElement>) => {
    setPurchaserDiscount(null);
    setDiscountType(event.target.value);
  };
  return (
    <Box>
      <RadioGroup
        onChange={handleDiscountTypeChange}
        value={discountType}
        aria-label="discount-type"
      >
        <FormControlLabel
          value="default"
          control={<Radio />}
          label="No default discount should be applied"
        />
        <FormControlLabel
          value="per-item"
          control={<Radio />}
          label="Apply discount per item purchased"
        />
      </RadioGroup>
      {discountType === "per-item" && (
        <TextField
          label="Discount"
          variant="outlined"
          type="number"
          value={purchaserDiscount}
          onChange={handleDiscountChange}
          InputProps={{
            endAdornment: "%",
          }}
        />
      )}
    </Box>
  );
};
